<template>
  <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <form @submit.prevent="handleSubmit">
      <div class="modal-window-header gray">
        <div class="modal-window-heading">
          <h3 class="icon-heading small">
            <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-object"></use></svg></span>
            <span>{{ title }}</span>
          </h3>
        </div>

        <fieldset>
          <div class="grid-x grid-padding-x">
            <TheTextInput v-model.trim="form.fromName" autofill="off" autocomplete="off" containerClassName="cell medium-6" :label="'Avsender navn'" :placeholder="'Avsender navn…'" name="email_from_name" required v-validate="nameRule"/>
            <TheEmailInput v-model.trim="form.fromMail" autofill="off" autocomplete="off" containerClassName="cell medium-6" :label="'Avsender e-post'" :placeholder="'Avsender e-post…'" name="email_from_mail" required v-validate="mailRule"/>
            <!-- <TheSwitchInput v-model="form.sendBcc" containerClassName="cell auto" :small="true" label="Send kopi til avsender" labelTrue="Ja" labelFalse="Nei" :trueValue="true" :falseValue="false"/> -->
          </div>
        </fieldset>
      </div>

      <div class="modal-window-body">
        <fieldset>
          <div class="grid-x grid-padding-x" id="error-fix-container">
            <TheTextInput v-model.trim="form.toName" autofill="off" autocomplete="off" containerClassName="cell medium-6" :label="'Mottaker navn'" :placeholder="'Mottaker navn…'" name="email_to_name" required v-validate="nameRule"/>
            <TheEmailInput v-model.trim="form.toMail" autofill="off" autocomplete="off" containerClassName="cell medium-6" :label="'Mottaker e-post'" :placeholder="'Mottaker e-post…'" name="email_to_mail" required v-validate="mailRule"/>

            <TheTextInput v-model.trim="form.subject" containerClassName="cell medium-12" :label="'Emne'" :placeholder="'Emne…'" name="email_subject" required v-validate="subjectRule"/>
            <TheTextArea v-model="form.content" containerClassName="cell medium-12" :label="'Tekst'" :placeholder="'E-post tekst…'" name="email_content"  :rows="12" required v-validate="contentRule"/>
          </div>
        </fieldset>
      </div>

      <div class="modal-window-footer">
        <div class="grid-x">
          <div class="cell align-right">
            <a href="javascript:;" @click="closeButtonClick()" class="button primary transparent large modal-close show-for-medium">Avbryt</a>

            <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="handleSubmit()" class="button primary submit large">Send</a>
            <a v-else-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large loading">Send <span class="loader-spinner"></span></a>
            <a v-else href="javascript:;" class="button primary submit large" disabled>Send</a>
          </div>
        </div>
      </div>

      <a href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
        <span>Lukk</span>
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
      </a>
    </form>
  </overlay-scrollbars>
</template>

<script>
import KundeService from '@/services/KundeService'
import TheAutoCompleteInput from '../Inputs/TheAutoCompleteInput'
// import bus from '@/plugins/event-bus'

export default {
  name: 'KundeEmailModal',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    TheAutoCompleteInput
  },
  props: {
    kunde: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: false
    }
  },

  data () {
    return {
      /* eslint-disable-next-line */
      title: 'Send e-post',
      form: {
        subject: '',
        content: '',
        sendBcc: false,
        fromName: '',
        fromMail: '',
        toName: '',
        toMail: ''
      }
    }
  },
  computed: {
    nameRule: function () {
      return 'required|max:100'
    },
    mailRule: function () {
      return 'required|email'
    },
    subjectRule: function () {
      return 'required|max:75'
    },
    contentRule: function () {
      return 'required'
    }
  },
  created () {
    // Make the form object
    this.setup()
  },
  mounted () {
    window.jQuery('.modal-window-body').attr('tabindex', -1).css({outline: 'none'}).focus()
  },
  methods: {
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.setFormProcessing(false)
        this.setFormLoading(false)
        this.$emit('close')
      }
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Feil', 'Vennligst korriger feil i skjemaet')
          } else {
            KundeService.sendEmail(this.kunde.Kundenr, this.form)
              .then((response) => {
                // Show success alert
                this.$helpers.showSuccessAlert('Email har blitt sendt')

                // Must reload kunde historikk
                this.$store.dispatch('kundehistory/load', this.kunde.Kundenr)

                this.closeModal()
              })
              .catch((error) => {
                console.log('Error')
                console.log(error)

                const custom = this.$helpers.getCustomErrors(error)

                if (this._.has(custom, 'email')) {
                  const message = Array.isArray(custom.email) ? custom.email.join('\n') : 'Noe gikk feil, vennligst prøv igjen.'
                  this.$helpers.showErrorAlert('Feil', message)
                } else {
                  this.$helpers.showErrorAlert('Feil', 'Noe gikk feil, vennligst prøv igjen.')
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    },
    setupKontraktMangler: function () {
      let name = this.form.fromName === 'Blomqvist'
        ? 'Blomqvist'
        : this.form.fromName + ' (Kontrakstansvarlig)'

      this.title = 'Send e-post: Mangler i kontrakt #' + this.data.kontrakt.Kontraktnr

      this.$set(this.form, 'title', this.title)
      this.$set(this.form, 'subject', 'Fra Blomqvist: Vi trenger mer informasjon fra deg før auksjonen')
      this.$set(this.form, 'content', `Hei

Følgende mangler i din kontrakt nr. ${this.data.kontrakt.Kontraktnr} for at objektene skal bli klare for auksjon:

- Signering av kontrakt  Svar gjerne på denne eposten at du godkjenner kontrakten
- Kopi legitimasjon
- Fullstendig adresse
- Ditt mobilnummer
- Ditt kontonummer

Fint om du kan sende oss dette så fort som mulig ved å svare på denne e-posten.

Vi ser frem til auksjonen og takker for at du velger Blomqvist.

Vennlig hilsen
${name}`)
    },
    setup: function () {
      const me = this.$store.getters.getUser

      // Setup sender
      this.$set(this.form, 'fromName', me.full_name || 'Blomqvist')
      this.$set(this.form, 'fromMail', me.Email || 'kontakt@blomqvist.no')

      // Setup receiver
      this.$set(this.form, 'toName', this.kunde.full_name || '')
      this.$set(this.form, 'toMail', this.kunde.Email || '')

      // Determine type of email
      switch (this.type) {
        case 'kontrakt-mangler':
          // Validate
          if (!this.data.kontrakt && !this.data.kontrakt.Kontraktnr) {
            this.$helpers.showErrorAlert('Feil', 'Denna type av email er ikke konfigurert enda')
            this.closeModal()
          } else {
            this.setupKontraktMangler()
          }
          break
        default:
          this.title = 'Send e-post'
          break
      }
    }
  }
}
</script>
<style>
  /** Temporary fix */
  #error-fix-container .form-error-label {
    bottom: 0;
    top: calc(100% + 0.2rem)
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/KundeEmailModal.vue